export const getMaxUsersFromSize = size => {
  switch (size) {
    case 'S':
      return 2
    case 'M':
      return 5
    case 'L':
      return 10
    case 'XL':
      return 25
    case 'XXL':
      return Infinity
  }
}

export const shouldUpgradeSubscription = usersLength => usersLength === 1 || usersLength === 10
